import React from 'react';
import Class11Fieldtrip2024 from 'views/Class11Fieldtrip2024';

const VissionAndMissionPage = () => {
  return <Class11Fieldtrip2024/>;
};

export default VissionAndMissionPage;